/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productInnerVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: `productInnerVisualSwiperNext`,
        prevEl: `productInnerVisualSwiperPrev`,
    },
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productInnerVisualThumbsSlide.active")?.classList.remove("active");
            document.querySelectorAll(".productInnerVisualThumbsSlide")[this.realIndex]?.classList.add("active");

            // pause all videos
            document.querySelectorAll(".productInnerVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
});

document.querySelector('.productInnerVisualSwiperNext').addEventListener('click', function () {
    productSwiper.slideNext();
});
document.querySelector('.productInnerVisualSwiperPrev').addEventListener('click', function () {
    productSwiper.slidePrev();
});

// change slide on thumbnail click
document.querySelectorAll(".productInnerVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});

// setup dropdowns
document.querySelectorAll(".productInnerContentInfoItemQuestion").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});


/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productInnerContentOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productInnerContentATC").disabled = true;
        document.querySelector("#productInnerContentATC").textContent = "Not Available";
        return;
    }

    // update the variant ID within the price [this exists for intelligems]
    document.querySelector("#productInnerContentPriceReal").dataset.variantId = activeVariant.id;
    document.querySelector("#productInnerContentPriceCompare").dataset.variantId = activeVariant.id;


    // update the variant ID within the price [this exists for intelligems]
    document.querySelector("#productInnerContentPriceReal").dataset.variantId = activeVariant.id;
    document.querySelector("#productInnerContentPriceCompare").dataset.variantId = activeVariant.id;

    // update price
    document.querySelector("#productInnerContentPriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productInnerContentPriceReal").classList.add("sale");
        document.querySelector("#productInnerContentPriceCompare").textContent = price(activeVariant.compare_at_price);
    } else {
        document.querySelector("#productInnerContentPriceReal").classList.remove("sale");
        document.querySelector("#productInnerContentPriceCompare").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productInnerContentATC").classList.remove("oos");
        document.querySelector("#productInnerContentATC").textContent = "Add To Cart";
        document.querySelector("#productInnerContentATC").disabled = false;
    }
    // check if oos is enabled
    else if (variantIDToEnabledOOS[activeVariant.id] === "true") {
        document.querySelector("#productInnerContentATC").classList.add("oos");
        document.querySelector("#productInnerContentATC").textContent = "Sold Out - Notify Me When Available";
        document.querySelector("#productInnerContentATC").disabled = false;

    } else {
        document.querySelector("#productInnerContentATC").textContent = "Sold Out";
        document.querySelector("#productInnerContentATC").disabled = true;
    }

    document.querySelectorAll('.productInnerVisualSwiperTag').forEach(tag => {
        tag.classList.remove("active");
    });

    // check if this variant has a tag
    let variantTag = document.querySelector(`#tag-${activeVariant.id}`);
    if (variantTag.dataset.enabled === "true") {
        // show tag
        variantTag.classList.add("active");
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// On color label change
document.querySelectorAll(".productInnerContentOptionItemColorsLabel input")?.forEach(element => {
    element.addEventListener("change", function () {

        // update label
        document.querySelector("#colorLabel").textContent = 'Color: ' + this.value;

        // find the active variants image
        let image = activeVariant?.featured_image.position;
        if (image) {
            // change slide
            productSwiper.slideTo(image - 1);
        }
    });
});

updateProduct();


// check if the url variant has a featured image on page load
if (activeVariant?.featured_image) {
    // change slide
    productSwiper.slideTo(activeVariant.featured_image.position - 1);

    // update label with currently selected color
    if (document.querySelector("#colorLabel")) {
        document.querySelector("#colorLabel").textContent = 'Color: ' + activeVariant.options[0];
    }
}

/****************
 * Product Quantity
 */

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelector("#productInnerContentATC").addEventListener("click", async function () {

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        await sendKlaviyoBackInStockRequest(email, activeVariant.id);

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


/**************
 Measure Dialog
 ***************/

// play button listener (if they click the video)
document.querySelectorAll(".measureBodyStepsItemBtn").forEach(function (element) {
    element.addEventListener("click", function () {

        // hide play button
        this.querySelector(".measureBodyStepsItemBtnPlay").classList.add("active");

        //pause all other videos if they're playing and show their play button
        document.querySelectorAll(".measureBodyStepsItemBtn").forEach(function (other_video) {
            if ((other_video !== element) && (!other_video.querySelector(".measureBodyStepsItemBtnVid").paused)) {
                other_video.querySelector(".measureBodyStepsItemBtnVid").pause();
                other_video.querySelector(".measureBodyStepsItemBtnPlay").classList.remove("active");
            }
        });

        // if this video is paused, play it, otherwise pause it (toggles play/pause)
        if (this.querySelector(".measureBodyStepsItemBtnVid").paused) {
            this.querySelector(".measureBodyStepsItemBtnVid").play();
            this.querySelector(".measureBodyStepsItemBtnPlay").classList.add("active");
        } else {
            this.querySelector(".measureBodyStepsItemBtnVid").pause();
            this.querySelector(".measureBodyStepsItemBtnPlay").classList.remove("active");
        }

    });
});


// open measure label dialog
document.querySelector('#productInnerContentMeasure').addEventListener('click', function () {
    // open measure label
    document.querySelector("#measure").showModal();
    document.querySelector("body").classList.add("noScroll");
});

// close event
document.querySelector("#measure").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close measure
function closeMeasure() {
    document.querySelector("#measure").close();
    document.querySelector("body").classList.remove("noScroll");
}

//close measure event listener
document.querySelectorAll(".closeMeasure").forEach(function (element) {
    element.addEventListener("click", closeMeasure);
});

document.querySelector("#measure").addEventListener("click", function (e) {
    if (e.target === this) {
        closeMeasure();
    }
})


// open size label dialog
document.querySelector('#productInnerContentOptionItemGuide')?.addEventListener('click', function () {
    // open size label
    document.querySelector("#size").showModal();
    document.querySelector("body").classList.add("noScroll");
});

// close event
document.querySelector("#size").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close size
function closeSize() {
    document.querySelector("#size").close();
    document.querySelector("body").classList.remove("noScroll");
}

//close size event listener
document.querySelectorAll(".closeSize").forEach(function (element) {
    element.addEventListener("click", closeSize);
});

document.querySelector("#size").addEventListener("click", function (e) {
    if (e.target === this) {
        closeSize();
    }
})